import { ExecutiveBusinessReviewNameFields } from "globalConstants";

export const getMappedBusinessReviewData = data => {
	return {
		[ExecutiveBusinessReviewNameFields.businessMessage]: data,
	};
};
